(function(){
    'use strict'

    angular
    .module('app.usuarios')
    .controller('CrearPublicUsuario', CrearPublicUsuario);

    CrearPublicUsuario.$inject = ['$q', '$scope', '$animationsSrv', 'UsuariosService', 'logger', '$location', 'ApiBaseService'];

    function CrearPublicUsuario($q, $scope, $animationsSrv, UsuariosService, logger, $location, ApiBaseService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.usuarioId = 0;
        
        vm.grupos = [];

        const GRUPO_ATLETAS = 2;

        vm.usuario = {
            id: 0,
            grupoId: GRUPO_ATLETAS,
            tallaId: 0,
            estadoVacunacionId: 0,
            lateralidad: 0,
            sexo: 0
        };

        vm.uiData = {
            fechaNacimientoOpened: false,
            openFechaNacimiento(){
                this.fechaNacimientoOpened = !this.fechaNacimientoOpened;
            }
        };

        vm.tallas = [];
        vm.estadosVacunacion = [];


        getComboData(vm.tallas, 'api/Tallas', null, 'Error al cargar las tallas');
        getComboData(vm.estadosVacunacion, 'api/EstadosVacunacion', null, 'Error al cargar los estados de vacunacion');

        function getComboData(array, apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                array.splice(0);
                array.push(...data);
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        function doFormValidations()
        {
            validateSelectProperty($scope.usuarioForm, vm.usuario, 'tallaId' );
            validateSelectProperty($scope.usuarioForm, vm.usuario, 'estadoVacunacionId' );
            validateSelectProperty($scope.usuarioForm, vm.usuario, 'sexo' );
            validateSelectProperty($scope.usuarioForm, vm.usuario, 'lateralidad' );
        };

        vm.save = function(){

            $scope.submitted = true;

            if(vm.usuario.grupoId == -1){
                $scope.usuarioForm.usergrupo.$setValidity("different", false);
            }

            doFormValidations();

            if($scope.usuarioForm.$valid){
                vm.usuario.id = 0;
                saveUser();
            }
            else{
                logger.error('Por favor corrija los datos');
            }
        
        };

        function saveUser() {
            var promise = UsuariosService.savePublic(vm.usuario);
                
            promise
            .then(function(response){
                logger.success('Usuario creado con éxito.');
                $location.path( "/" ); 
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                    logger.error(`Hubo un erro al crea el usuario: ${error.data.Message}`);
                        break;
                
                    default:
                        logger.error('Hubo un erro al crea el usuario');
                        break;
                }
            }); 
        }

        function validateSelectProperty(form, object, property){
            if(object[property] == 0){
                form[property].$setValidity("different", false);
                return false;
            }
            else{
                form[property].$setValidity("different", true);
                return true;
            }
        };

        vm.onSelectChanged = function(property){

            switch (property) {
                case "tallaId":
                    onTallaIdChanged(property);
                    break;
                case "estadoVacunacionId":
                    onEstadoVacunacionIdChanged(property);
                    break;
                case "sexo":
                    onSexoChanged(property);
                    break;
                case "lateralidad":
                    onLateralidadChanged(property);
                    break;
                default:
                    break;
            }
        };

        function onTallaIdChanged(property)
        {
            validateSelectProperty($scope.usuarioForm, vm.usuario, property );
        };

        function onSexoChanged(property)
        {
            validateSelectProperty($scope.usuarioForm, vm.usuario, property );
        };

        function onEstadoVacunacionIdChanged(property)
        {
            validateSelectProperty($scope.usuarioForm, vm.usuario, property );
        };

        function onLateralidadChanged(property)
        {
            validateSelectProperty($scope.usuarioForm, vm.usuario, property );
        };

    }
})();